"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildValueProvider = buildValueProvider;
const AnonymousClient_1 = require("@juvare/platform-sdk-js/AnonymousClient");
/**
 * Deprecated, use `buildPublicDataValueProvider` or `buildStorageValueProvider`.
 *
 * @deprecated
 */
function buildValueProvider(appName, classifierName, label, displayOrder, entityName, getValues) {
    const client = new AnonymousClient_1.AnonymousClient(appName, entityName ?? classifierName);
    return {
        type: 'classifier.' + classifierName,
        label: label,
        getValues: getValues
            ? (params) => getValues(client, params)
            : () => client
                .storageList({
                filter: [{ column: 'status', op: '=', value: 'active' }],
                orderBy: displayOrder ? [{ column: 'displayOrder' }, { column: 'name' }] : [{ column: 'name' }],
            })
                .then((result) => result.rows.map((row) => ({ value: row.id, label: row.columns.name }))),
    };
}
